import { Col, Row, Typography } from 'antd';
import { commonHelpers } from 'utilities/helpers';
import { RangeData } from '../../CU-056-02/Models/Range';

export const ReferencePriceComponent = (range: RangeData) => {
    return (
        <>
            <Row gutter={[40, 0]} className="h-fit price-range-info w-full md:w-2/3 2xl:w-1/2">
                <Row
                    className="title-badge h-fit badge-2"
                    style={{ marginTop: 33, display: 'flex', alignItems: 'center' }}
                >
                    <Col style={{ marginLeft: '5%', fontSize: '16px' }}>想定売却価格</Col>
                </Row>
                <Row className="price-estimate h-fit">
                    <Col className="price-estimate h-fit">
                        {commonHelpers.formatMoney(Number(range.min))} ~{' '}
                        {commonHelpers.formatMoney(Number(range.max))}{' '}
                        <span style={{ fontSize: '24px', marginLeft: 5 }}> 万円</span>
                    </Col>
                </Row>
                <Row className=" w-full h-fit">
                    <Col>
                        <Typography.Text className="title">
                            ※本価格はあくまで参考価格となり、実際の売却価格と異なることがあります。
                        </Typography.Text>
                    </Col>
                </Row>
            </Row>
        </>
    );
};
